import { render, staticRenderFns } from "./TicimaxKategori.vue?vue&type=template&id=d77192c4&scoped=true"
import script from "./TicimaxKategori.vue?vue&type=script&lang=js"
export * from "./TicimaxKategori.vue?vue&type=script&lang=js"
import style0 from "./TicimaxKategori.vue?vue&type=style&index=0&id=d77192c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77192c4",
  null
  
)

export default component.exports